<template>
  <a-spin :spinning="loading">
    <a-card :bordered="false">
      <div>
        <a-form :form="form" v-if="false">
          <a-row>
            <a-col :span="12" v-if="false">
              <a-form-item label="购销合同" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select
                  v-decorator="[
                    'sell_contract_id',
                    {
                      rules: [
                        { required: true, message: '请选择' }
                      ],
                    },
                  ]"
                  placeholder="选择"
                  show-search
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option :key="key" :value="val.id" v-for="(val, key) in sellContractList">{{ val.number }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="合同编号" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input disabled v-decorator="['system_contract_number', {rules: [{required: true, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="合同号"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="合同协议号" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input disabled v-decorator="['contract_protocol_number', {rules: [{required: true, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="合同协议号"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="交货运输方式" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select
                  v-decorator="[
                    'transport_way',
                    {
                      rules: [
                        { required: true, message: '请选择' }
                      ],
                    },
                  ]"
                  placeholder="选择"
                  allow-clear
                  option-filter-prop="children"
                  :filter-option="filterOption">
                  <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.trade_logistics_transport_way">{{ val }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="交货运输工具名称" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input v-decorator="['delivery_conveyance', {rules: [{required: false, message: '必填项，请填写信息'}, {max:128, message: '输入超出长度限制'}]}]" allow-clear placeholder="交货运输工具名称"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="交货日期" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-date-picker
                  style="width: 100%"
                  v-decorator="['delivery_date', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                  format="YYYY-MM-DD"
                  placeholder="交货日期"
                  value-format="yyyy-MM-DD"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="交货地" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input v-decorator="['delivery_address', {rules: [{required: true, message: '必填项，请填写信息'}, {max:128, message: '输入超出长度限制'}]}]" allow-clear placeholder="交货地" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="提货日期" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-date-picker
                  style="width: 100%"
                  v-decorator="['pick_up_date', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                  format="YYYY-MM-DD"
                  placeholder="提货日期"
                  value-format="yyyy-MM-DD"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="提货地" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input v-decorator="['pick_up_address', {rules: [{required: true, message: '必填项，请填写信息'}, {max:128, message: '输入超出长度限制'}]}]" allow-clear placeholder="提货地" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="交货运输方式" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select
                  v-decorator="[
                    'pick_up_transport_way',
                    {
                      rules: [
                        { required: true, message: '请选择' }
                      ],
                    },
                  ]"
                  placeholder="选择"
                  allow-clear
                  option-filter-prop="children"
                  :filter-option="filterOption">
                  <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.trade_logistics_transport_way">{{ val }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="提货运输工具名称" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input v-decorator="['pick_up_conveyance', {rules: [{required: false, message: '必填项，请填写信息'}, {max:128, message: '输入超出长度限制'}]}]" allow-clear placeholder="提货运输工具名称" />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <a-form :form="form">
          <a-row>
            <a-col :span="24">
              <a-divider orientation="left">
                关联信息
              </a-divider>
            </a-col>
            <a-col :span="12">
              <a-form-item label="采销全流程" :label-col="labelCol" :wrapper-col="wrapperCol">
                {{ this.data['project'] }}
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-divider orientation="left">
                合同信息
              </a-divider>
            </a-col>
            <a-col :span="12">
              <a-form-item label="编号" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input disabled v-decorator="['number', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="提单号" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input v-decorator="['bill_of_lading_number', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="提单签发日期" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-date-picker
                  style="width: 100%"
                  v-decorator="['bill_of_lading_date', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                  format="YYYY-MM-DD"
                  placeholder="请选择"
                  value-format="yyyy-MM-DD"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="发货人" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input v-decorator="['shipper', {rules: [{required: true, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="承运人" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input v-decorator="['carrier', {rules: [{required: true, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="收货人" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input v-decorator="['consignee', {rules: [{required: true, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="通知方" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input v-decorator="['notify_party', {rules: [{required: false, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="装货港" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input v-decorator="['loading_port', {rules: [{required: false, message: '必填项，请填写信息'}, {max:256, message: '输入超出长度限制'}]}]" allow-clear placeholder="交货地" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="卸货港" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input v-decorator="['discharge_port', {rules: [{required: false, message: '必填项，请填写信息'}, {max:256, message: '输入超出长度限制'}]}]" allow-clear placeholder="交货地" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="货物扩展分类" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select
                  v-decorator="[
                    'cargo_category',
                    {
                      rules: [
                        { required: true, message: '请选择' }
                      ],
                    },
                  ]"
                  placeholder="请选择"
                  allow-clear
                  option-filter-prop="children"
                  @change="cargoCategoryChange"
                  :filter-option="filterOption">
                  <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.trade_lading_bill_type">{{ val }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="24" v-if="selectedCargoCategory">
              <a-divider orientation="left">
                {{ selectedCargoCategory }}
              </a-divider>
            </a-col>
            <a-col :span="12" v-if="selectedCargoCategoryIndex === '1'">
              <a-form-item label="罐号" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input v-decorator="['tank_number', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
              </a-form-item>
            </a-col>
            <a-col :span="12" v-if="selectedCargoCategoryIndex === '1'">
              <a-form-item label="入罐日期" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-date-picker
                  style="width: 100%"
                  v-decorator="['intake_date', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                  format="YYYY-MM-DD"
                  placeholder="请选择"
                  value-format="yyyy-MM-DD"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12" v-if="selectedCargoCategoryIndex === '2'">
              <a-form-item label="卸货日期" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-date-picker
                  style="width: 100%"
                  v-decorator="['discharge_date', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                  format="YYYY-MM-DD"
                  placeholder="请选择"
                  value-format="yyyy-MM-DD"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12" v-if="selectedCargoCategoryIndex === '3'">
              <a-form-item label="铅封号" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input v-decorator="['seal_number', {rules: [{required: true, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
              </a-form-item>
            </a-col>
            <a-col :span="12" v-if="selectedCargoCategoryIndex === '3'">
              <a-form-item label="箱型" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select
                  v-decorator="[
                    'container_type',
                    {
                      rules: [
                        { required: true, message: '请选择' }
                      ],
                    },
                  ]"
                  placeholder="请选择"
                  allow-clear
                  option-filter-prop="children"
                  :filter-option="filterOption">
                  <a-select-option :key="key" :value="val" v-for="(val, key) in this.$Dictionaries.trade_container_type">{{ val }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12" v-if="selectedCargoCategoryIndex === '3'">
              <a-form-item label="箱量" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input-number :precision="4" style="width: 50%" v-decorator="['container_count', {rules: [{required: false, message: '必填项，请填写信息'}]}]" allow-clear placeholder="请输入" />
              </a-form-item>
            </a-col>
            <a-col :span="12" v-if="selectedCargoCategoryIndex === '1'">
              <a-form-item label="对应存量" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input-number :precision="4" style="width: 50%" v-decorator="['tank_inventory', {rules: [{required: false, message: '必填项，请填写信息'}]}]" allow-clear placeholder="请输入" />
              </a-form-item>
            </a-col>
            <a-col :span="12" v-if="selectedCargoCategoryIndex === '1'">
              <a-form-item label="岸罐数量" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input-number :precision="4" style="width: 50%" v-decorator="['shore_tank_qty', {rules: [{required: false, message: '必填项，请填写信息'}]}]" allow-clear placeholder="请输入" />
              </a-form-item>
            </a-col>
            <a-col :span="12" v-if="selectedCargoCategoryIndex !== undefined">
              <a-form-item label="毛重" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input-number :precision="4" style="width: 50%" v-decorator="['gross_weight', {rules: [{required: false, message: '必填项，请填写信息'}]}]" allow-clear placeholder="请输入" />
              </a-form-item>
            </a-col>
            <a-col :span="12" v-if="selectedCargoCategoryIndex !== undefined">
              <a-form-item label="净重" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input-number :precision="4" style="width: 50%" v-decorator="['net_weight', {rules: [{required: false, message: '必填项，请填写信息'}]}]" allow-clear placeholder="请输入" />
              </a-form-item>
            </a-col>
            <a-col :span="12" v-if="selectedCargoCategoryIndex !== undefined">
              <a-form-item label="单位" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select
                  v-decorator="[
                    'unit',
                    {
                      rules: [
                        { required: false, message: '请选择' }
                      ],
                    },
                  ]"
                  placeholder="选择"
                  show-search
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.unit">{{ val }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="24" v-if="selectedCargoCategoryIndex !== undefined">
              <a-divider orientation="left">
                {{ selectedCargoCategory }}对应凭证
              </a-divider>
            </a-col>
            <a-col :span="24" v-if="selectedCargoCategoryIndex !== undefined">
              <a-form-item label="附件" :label-col="buttonCol.labelCol" :wrapper-col="buttonCol.wrapperCol">
                <a-button icon="plus" @click="handleAddAttachment">新建</a-button>
                <a-table
                  bordered
                  :data-source="otherData.attachment"
                  :columns="attachmentColumns"
                  v-if="this.otherData.attachment.length > 0"
                  :pagination="false"
                  key="key">
                  <template slot="action" slot-scope="text, record">
                    <a :href="record.url" target="_blank">查看</a>
                    <a-divider type="vertical"/>
                    <a-popconfirm
                      v-if="otherData.attachment.length"
                      title="确定删除?"
                      @confirm="() => onAttachmentDelete(record.key)"
                    >
                      <a href="javascript:;">删除</a>
                    </a-popconfirm>
                  </template>
                </a-table>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <a-row>
          <a-col span="6" :offset="8">
            <a-button type="primary" html-type="submit" @click="handleSubmit">提交</a-button>
          </a-col>
          <a-col span="10">
            <a-button @click="handleGoBack">返回</a-button>
          </a-col>
        </a-row>
      </div>
      <attachment-create-form
        ref="attachmentCreateForm"
        @cancel="handleAddCancel"
        @ok="handleOk"
        :record="undefined"
        :visible="visibleFrom"
        v-if="visibleFrom"
        :loading="confirmLoadingFrom"
        :model="undefined" />
    </a-card>
  </a-spin>
</template>

<script>
import moment from 'moment'
import pick from 'lodash.pick'
import AttachmentCreateForm from '../attachment/modules/CreateForm'
import { lading_bill_list, lading_bill_update } from '@/api/trade_lading_bill'
const fields = ['number', 'bill_of_lading_number', 'bill_of_lading_date', 'shipper', 'carrier', 'consignee',
  'notify_party', 'loading_port', 'discharge_port', 'cargo_category', 'tank_number',
'intake_date', 'discharge_date', 'seal_number', 'container_type', 'container_count',
'tank_inventory', 'shore_tank_qty', 'gross_weight', 'net_weight', 'unit']
export default {
  name: 'TableEdit',
  components: {
    AttachmentCreateForm
  },
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 15 }
      },
      buttonCol: {
        labelCol: {
          xs: { span: 6 },
          sm: { span: 3 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 15 }
        }
      },
      form: this.$form.createForm(this),
      id: 0,
      selectedCargoCategory: undefined,
      selectedCargoCategoryIndex: undefined,
      projectList: [],
      otherData: {
        attachment: []
      },
      attachmentColumns: [
        {
          title: '名称',
          dataIndex: 'name'
        },
        {
          title: '附件',
          dataIndex: 'url'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      data: {},
      loading: false,
      confirmLoadingFrom: false,
      visibleFrom: false
    }
  },
  mounted () {
    this.loadLogisticsData()
  },
  methods: {
    moment,
    handleGoBack () {
      // this.$emit('onGoBack')
      this.$router.go(-1)
    },
    onAttachmentDelete (key) {
      const dataSource = [...this.otherData.attachment]
      this.otherData.attachment = dataSource.filter(item => item.key !== key)
    },
    handleAddAttachment () {
      this.visibleFrom = true
    },
    loadLogisticsData () {
      this.loading = true
      lading_bill_list({ id: this.$route.params.id })
        .then(res => {
          console.log(res.data, '我是数据列表@')
          const list = res.data.entries
          if (list && list.length > 0) {
            this.data = list[0]
            this.id = this.data.id
            this.data.cargo_category = '' + this.data.cargo_category
            this.selectedCargoCategory = this.$Dictionaries.trade_lading_bill_type[this.data.cargo_category]
            this.selectedCargoCategoryIndex = this.data.cargo_category
            this.data = { ...this.data, ...this.data.detail }
            this.data.unit = this.data.unit === '' ? undefined : this.data.unit
            this.loadEditInfo(this.data)
          }
        }).finally(() => {
          this.loading = false
      })
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    cargoCategoryChange (value) {
      if (this.selectedCargoCategoryIndex !== value) {
        if (this.selectedCargoCategoryIndex === '1') {
          this.form.setFieldsValue({ tank_number: undefined })
          this.form.setFieldsValue({ tank_inventory: undefined })
          this.form.setFieldsValue({ shore_tank_qty: undefined })
          this.form.setFieldsValue({ intake_date: undefined })
        } else if (this.selectedCargoCategoryIndex === '2') {
          this.form.setFieldsValue({ discharge_date: undefined })
        } else if (this.selectedCargoCategoryIndex === '3') {
          this.form.setFieldsValue({ container_type: undefined })
          this.form.setFieldsValue({ container_count: undefined })
          this.form.setFieldsValue({ seal_number: undefined })
        }
        this.form.setFieldsValue({ gross_weight: undefined })
        this.form.setFieldsValue({ net_weight: undefined })
        this.form.setFieldsValue({ unit: undefined })
        this.otherData.attachment = []
      }
      this.selectedCargoCategoryIndex = value
      this.selectedCargoCategory = this.$Dictionaries.trade_lading_bill_type[value]
    },
    createDetail (values) {
      if (this.selectedCargoCategoryIndex === undefined) {
        return undefined
      }
      const detail = {}
      if (this.selectedCargoCategoryIndex === '1') {
        detail['tank_number'] = values['tank_number']
        detail['tank_inventory'] = values['tank_inventory']
        detail['shore_tank_qty'] = values['shore_tank_qty']
        detail['intake_date'] = values['intake_date']
      } else if (this.selectedCargoCategoryIndex === '2') {
        detail['discharge_date'] = values['discharge_date']
      } else if (this.selectedCargoCategoryIndex === '3') {
        detail['container_type'] = values['container_type']
        detail['container_count'] = values['container_count']
        detail['seal_number'] = values['seal_number']
      }
      detail['gross_weight'] = values['gross_weight']
      detail['net_weight'] = values['net_weight']
      detail['unit'] = values['unit']
      if (String(this.data.cargo_category) === String(this.selectedCargoCategoryIndex)) {
        if (this.data && this.data.detail && this.data.detail.id) {
          detail['id'] = this.data.detail.id
        }
      }
      return detail
    },
    handleSubmit () {
      const { form: { validateFields } } = this
      validateFields((err, values) => {
        console.log('我要提交接口', values)
        if (!err) {
          const detail = this.createDetail(values)
          if (detail) {
            values['detail'] = detail
          }
          values['attachment'] = this.otherData.attachment
          lading_bill_update(values, this.id)
            .then((res) => {
              if (res.code === 1000) {
                this.handleGoBack()
                console.log(res, '修改成功')
              }
            })
        }
      })
    },
    loadEditInfo (data) {
      const { form } = this
      console.log(`将加载 ${this} 信息到表单`)
      new Promise((resolve) => {
        setTimeout(resolve, 0)
      }).then(() => {
        const formData = pick(data, fields)
        console.log('formData', formData)
        form.setFieldsValue(formData)
        this.otherData.attachment = this.data.detail.attachments ? this.data.detail.attachments.map(item => {
          item['key'] = Math.random() * 1000000
          return item
        }) : []
      })
    },
    handleAddCancel () {
      this.visibleFrom = false
      const form = this.$refs.attachmentCreateForm.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleOk () {
      const form = this.$refs.attachmentCreateForm.form
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values)
          // 新增
          values.url = values.url.fileList[0].url
          const current_date = new Date()
          values.key = current_date.getHours() + '' + current_date.getMinutes() + '' + current_date.getSeconds()
          this.otherData.attachment.push(values)
          this.visibleFrom = false
          form.resetFields()
        }
      })
    }
  }
}
</script>
